export default __webpack_public_path__ + "static/social-image-02166437f8434840cfa38181ed290401.png";